import {
  ADD_TO_CART,
  CLEAR_CART,
  COUNT_CART_TOTALS,
  REMOVE_CART_ITEM,
  TOGGLE_CART_ITEM_AMOUNT,
} from '../actions'
import CartItem from '../components/CartItem';

const cart_reducer = (state, action) => {
  if(action.type===ADD_TO_CART){
  const {id,color,amount,product}=action.payload;
  const tempItem=state.cart.find((i)=>i.id===id+color);
  if(tempItem){
  if(tempItem.amount + amount <= tempItem.max){
   tempItem.amount =tempItem.amount + amount;
  }else{
    tempItem.amount=tempItem.max;
  }
 return {...state} 
  }
  else{
  const newItem={
    id:id+color,
    name:product.name,
    color,
    amount,
    image:product.images[0].url,
    price:product.price,
    max:product.stock,
  }
    
  return {...state,cart:[...state.cart,newItem]};  
  }
}
  if(action.type===REMOVE_CART_ITEM){
    const newCart=state.cart.filter((item)=>{
      return item.id !== action.payload;
    });
    return {...state,cart:newCart};
  }
  if(action.type===CLEAR_CART){
    return {...state,cart:[]};
  }
  if(action.type===TOGGLE_CART_ITEM_AMOUNT){
  const {id,value}=action.payload;
  const tempCart=state.cart.map((item)=>{
    if(item.id===id){
     let newAmount;
    if(value==="inc"){
     newAmount=item.amount+1;
    if(newAmount>=state.max){
    newAmount=state.max;
    }
   }
    if(value==='dec'){
      newAmount=item.amount-1;
      if(newAmount<1){
        newAmount=1;
        }
    }
    return {...item,amount:newAmount};
    }
    else{
    return item;
    }
  });

    return{...state,cart:[...tempCart]};
  }  if(action.type===COUNT_CART_TOTALS){
    
   const {total_items,total_amount}=state.cart.reduce((total,cartItem)=>{
   total.total_items += cartItem.amount ;
   total.total_amount+= cartItem.price * cartItem.amount ;

    return total;
   },{total_items:0,total_amount:0})  


    return{...state,total_amount,total_items};
    
  }

  
  throw new Error(`No Matching "${action.type}" - action type`)
}

export default cart_reducer
